import script from "./DetailRequestBlockedMisuse.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailRequestBlockedMisuse.vue?vue&type=script&setup=true&lang=js"

import "./DetailRequestBlockedMisuse.vue?vue&type=style&index=0&id=cfb6b6f2&lang=scss&scoped=true"

import exportComponent from "/vue-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cfb6b6f2"]])

export default __exports__